"use strict";

exports.__esModule = true;
exports.TimelineSubscription = TimelineSubscription;
var _react = _interopRequireDefault(require("react"));
var _RealtimeConnection = require("../../API/RealtimeConnection");
var _excluded = ["timelineName", "query", "isCurrent", "normalize"],
  _excluded2 = ["plant", "tenant"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Subscribe to a timeline.
 */
function TimelineSubscription(_ref) {
  var timelineName = _ref.timelineName,
    query = _ref.query,
    _ref$isCurrent = _ref.isCurrent,
    isCurrent = _ref$isCurrent === void 0 ? true : _ref$isCurrent,
    normalize = _ref.normalize,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_RealtimeConnection.RealtimeDataSubscription, _extends({
    params: ["timeline", {
      entity: Object.assign({}, query, {
        name: timelineName
      }),
      isCurrent: isCurrent
    }],
    normalize: normalize ? normalize : normalizeTimelineValue
  }, extra));
}
function normalizeTimelineValue(doc) {
  if (doc == null) {
    return null;
  }
  var _doc$entity = doc.entity,
    _plant = _doc$entity.plant,
    _tenant = _doc$entity.tenant,
    entity = _objectWithoutPropertiesLoose(_doc$entity, _excluded2);
  var value = Object.assign({}, doc.dimensions, doc.measures);
  if (Object.keys(value).length === 0) {
    return null;
  }
  return Object.assign({}, entity, {
    type: doc.type,
    value: value,
    interval: {
      startMillis: Date.parse(doc.timestamp),
      endMillis: Date.parse(doc.timestamp_end)
    }
  });
}